<section id="main" class="bg-light">
     <div
          id="requestContainer"
          class="container"
     >
          <h1
               [innerHtml]="'AddDrivers' | translator: 'request'"
          >Add Driver(s)
          </h1>
          <p
               [innerHtml]="'AddDriversDescription' | translator: 'request'"
          >Add one or more drivers and associated licenses below.
          </p>
          <div class="row">
               <div class="col-12">
                    <div
                         *ngIf="serverValidationErrors.length > 0 && hasServerException === false"
                         class="alert alert-danger"
                    >
                         <p [innerHtml]="'CorrectErrors' | translator: 'request'">
                              Please correct the following errors and try again.
                         </p>
                         <ul class="mb-0">
                              <li
                                   *ngFor="let error of serverValidationErrors; index as i"
                                   [id]="i"
                              >
                                   {{error}}
                              </li>
                         </ul>
                    </div>
                    <div *ngIf="hasServerException === true"  class="alert alert-danger" [innerHtml]="'CSInfoInfo' | translator: 'base'">
                         An error was encountered. Please contact the PSP Customer Support Team at 
                         <a alt="call customer service" href="tel:8776429499" name="1-877-642-9499">1-877-642-9499</a> for information on completing this transaction. 
                         The PSP team is available by phone Monday through Thursday from 8 AM to 6 PM ET, and on Friday from 8 AM to 5 PM ET.
                    </div>
               </div>
          </div>

          <div
               class="row"
               id="recordRequest"
          >
               <div
                    class="overlay"
                    *ngIf="isSaving"
               >
                    <h1
                         class="heading"
                         [innerHtml]="'Processing' | translator: 'base'"
                    >Processing...</h1>
                    <img [alt]="'Processing' | translator: 'base'" />
               </div>
               <div
                    class="overlay"
                    *ngIf="isLoading"
               >
                    <h1
                         class="heading"
                         [innerHtml]="'Loading' | translator: 'base'"
                    >Loading...
                    </h1>
                    <img [alt]="'Loading' | translator: 'base'" />
               </div>

               <ng-template #UploadModal let-modal>
                    <div class="modal-header">
                         <h3
                              class="modal-title"
                              slot="header"
                         >
                              <span [innerHtml]="'uploadModalTitle' | translator: 'audit'">Add document for driver:</span> {{recordRequests[0].lastName}}
                         </h3>
                    </div>    
                    <div class="modal-body">
                         <div
                              class="overlay"
                              *ngIf="isUploading"
                         >
                              <div
                                   class="heading"
                                   [innerHtml]="'Processing' | translator: 'base'"
                              >Processing...</div>
                         </div>
                         <p
                              [innerHtml]="'UploadModalText1' | translator: 'audit'"
                         >Add one or more files here to complete your document submission.
                         </p>
                         <div class="alert alert-warning">
                              <p>
                                   <span
                                        [innerHtml]="'formsText5' | translator: 'audit'"
                                   >The driver's name, signature, and date must be included on the forms. Please remove or black out any other personally identifiable information, like date of birth, social security number, license number, etc.
                                   </span>
                              </p>
                         </div>
                         <h4
                              class="h5"
                              [innerHtml]="'uploadedFilesHeader' | translator: 'audit'"
                         >Uploaded files
                         </h4>
                         <p
                              class="text-center no-files-message"
                              *ngIf="probationDocuments.length === 0"
                              [innerHtml]="'noDocAttempts' | translator: 'audit'"
                         >No files uploaded yet.
                         </p>
                         <div
                              class="modal-submitted-documents"
                              *ngIf="probationDocuments.length > 0"
                         >
                              <table class="table table-vcr table-light table-collapsible">
                                   <thead>
                                        <tr>
                                             <th [innerHtml]="'docHeaderCol1' | translator: 'audit'">Submitted By</th>
                                             <th [innerHtml]="'docHeaderCol2' | translator: 'audit'">Received</th>
                                             <th [innerHtml]="'docName' | translator: 'request'">Name</th>
                                             <th [innerHtml]="'docHeaderCol3' | translator: 'audit'">Action</th>
                                        </tr>
                                   </thead>
                                   <tbody>
                                        <tr
                                             *ngFor="let doc of probationDocuments; index as i"
                                             :key="doc.documentId"
                                        >
                                             <td class="text-break">
                                                  <span 
                                                       class="cell-label" 
                                                       [innerHtml]="'docHeaderCol1' | translator: 'audit'"
                                        >Submitted By</span>
                                                  {{doc.creator}}
                                             </td>
                                             <td class="text-break">
                                                  <span 
                                                       class="cell-label" 
                                                       [innerHtml]="'docHeaderCol2' | translator: 'audit'"
                                        >Received</span>											
                                                  {{doc.created | date: 'MM/dd/yyyy'}}
                                             </td>
                                             <td class="text-break">
                                                  <span 
                                                       class="cell-label" 
                                                       [innerHtml]="'docName' | translator: 'request'"
                                        >Name</span>											
                                                  {{doc.fileName}}
                                             </td>
                                             <td>
                                                  <span 
                                                       class="cell-label" 
                                                       [innerHtml]="'docHeaderCol3' | translator: 'audit'"
                                        >Action</span>											
                                                  <button
                                                       (click)="removeDocument(doc.documentId, i)"
                                                       class="btn btn-danger btn-sm"
                                                  >
                                                       <span
                                                            [innerHtml]="'btnRemove' | translator: 'audit'"
                                                            [title]="'btnRemove' | translator: 'audit'"
                                                       >Remove</span>
                                                  </button>
                                             </td>
                                        </tr>
                                   </tbody>
                              </table>
                         </div>
                         <h4
                              class="h5"
                              [innerHtml]="'addDocumentsHeader' | translator: 'audit'"
                         >
                              Add document(s)
                         </h4>
                         <div class="file-upload-container">
                              <label for="" class="file-upload-label d-block position-relative overflow-hidden">
                                   <input type="file" class="file-upload-input bg-light form-control d-block overlayed" accept=".jpg, .jpeg, .png, .pdf" title="" multiple (change)="uploadDocuments($event)" id="uploadDocumentsId" #uploadDocumentsId>								
                                   <span class="file-upload-overlay overlayed">
                                        <div class="text-center px-3" aria-describedby="uploadDocumentsId">
                                             <strong>
                                                  <span [innerHtml]="'docUploadChooseOrDrop1' | translator: 'audit'"
                                                  [title]="'docUploadChooseOrDrop1' | translator: 'audit'">Choose File(s)</span>
                                                  <span class="ms-1" [innerHtml]="'docUploadChooseOrDrop2' | translator: 'audit'">or drag and drop file(s) here.</span>
                                             </strong>
                                        </div>
                                   </span>
                                   <span class="file-upload-overlay-focus overlayed pe-none"></span>
                              </label>
                         </div>
                         <p class="help-block pt-2">
                              <span
                                   class="fw-bold"
                                   [innerHtml]="'AcceptableFormats' | translator: 'audit'"
                              >Acceptable formats are PDF, JPG, and PNG.</span>
                         </p>
                    </div>
                    <div class="modal-footer" slot="footer">
                         <button
                         class="btn btn-primary"
                         (click)="completeDocumentUploads()"
                         [title]="'submitDocsBtn' | translator: 'audit'"
                         id="btnMakeDefaultOk"
                         name="btnMakeDefaultOk"
                         [disabled]="probationDocuments && probationDocuments.length === 0"
                         >
                         <span
                              class="pr-2"
                              [innerHtml]="'submitDocsBtn' | translator: 'audit'"
                         >Submit Document(s)</span>
                         </button>
                         <button
                         class="btn btn-outline-primary me-2"
                         (click)="cancelUploads()"
                         [title]="'cancel_button' | translator: 'base'"
                         id="btnMakeDefaultCancel"
                         name="btnMakeDefaultCancel"
                         >
                         <span [innerHtml]="'cancel_button' | translator: 'base'">Cancel</span>
                         </button>
                    </div>
               </ng-template>

               <ng-template #InvalidFileTypeModal let-modal>
                    <div class="modal-header">
                         <h3
                              id="invalidFileTypeModalTitle" 
                              class="modal-title"
                              slot="header"
                         >
                              <span [innerHtml]="'invalidFileTypeTitle' | translator: 'audit'">Invalid File Type</span>
                         </h3>
                    </div>
                    <div class="modal-body">
                         <div *ngIf="!isValidFileType" slot="body" class="alert alert-warning">
                              <span
                              [innerHtml]="'invalidFileTypeText' | translator: 'audit'"
                              >You can only upload PDF, JPG, PNG, or JPEG files|
                              </span>
                         </div>
                    </div>
                    <div class="modal-footer">
                         <button class="btn btn-primary"
                              [title]="'ok_button' | translator: 'base'"
                              name="okay" (click)="closeInvalidFileTypeModal()">
                         <span [title]="'ok_button' | translator: 'base'" [innerHtml]="'ok_button' | translator: 'base'">OK</span>
                         </button>
                    </div>
               </ng-template>

               <div class="col-lg-8">
                    <fieldset
                         class="card shadow-sm rounded-0 border-0 mb-3"
                         *ngFor="let r of recordRequests; index as index"
                         [id]="'driver-'+index"
                    >
                         <div class="card-body">
                              <legend
                                   class="h4"
                                   [innerHtml]="translate('DriverInformation', r)"
                              >
                              </legend>
                              <div class="row gx-2">
                                   <div class="col-12 col-md-6 col-xl mb-3 mb-xl-0 pe-md-2 pe-xl-2">
                                        <label
                                             [id]="getUniqueIdentifier('driverLastName', 'label', [index])" 
                                             [for]="getUniqueIdentifier('driverLastName', 'input', [index])" 
                                             class="form-label"
                                        >
                                             <span [innerHtml]="'LastName' | translator: 'base'">Last Name</span>
                                             <span
                                                  class="text-danger text-center ms-1"
                                                  [title]="'Required' | translator: 'base'"
                                             >*</span>
                                        </label>
                                        <input
                                             type="text"
                                             [id]="getUniqueIdentifier('driverLastName', 'input', [index])"
                                             [name]="getUniqueIdentifier('driverLastName', 'input', [index])"
                                             [attr.aria-describedby]="getUniqueIdentifier('driverLastName', 'label', [index])"
                                             class="bg-light form-control"
                                             [(ngModel)]="r.lastName"
                                             [title]="'LastName' | translator: 'base'"
                                             maxlength="30"
                                             (change)="driverInfoLastNameChange(r)"
                                        />
                                        <span
                                             class="help-block text-danger"
                                             *ngIf="r.lastNameValidation.hasRequiredError && r.lastNameValidation.isDirty"
                                             [innerHtml]="'LastNameRequired' | translator: 'request'"
                                        >Last name is required.
                                        </span>
                                        <span
                                             class="help-block text-danger"
                                             *ngIf="r.lastNameValidation.hasInvalidCharacters"
                                             [innerHtml]="'LastNameInvalid' | translator: 'request'"
                                        >Last Name contains invalid value(s). Please use letters only.
                                        </span>
                                        <span
                                             class="help-block text-danger"
                                             *ngIf="r.lastNameValidation.hasTooManyCharacters"
                                             [innerHtml]="'LastNameMax30' | translator: 'request'"
                                        >Last name must be 30 characters or less.
                                        </span>
                                   </div>
                                   <div class="col-12 col-md-6 col-xl mb-3 mb-xl-0 ps-md-2 px-xl-2">
                                        <label
                                             [id]="getUniqueIdentifier('driverFirstName', 'label', [index])"
                                             [attr.name]="getUniqueIdentifier('driverFirstName', 'label', [index])"
                                             [for]="getUniqueIdentifier('driverFirstName', 'input', [index])"
                                             class="form-label"
                                        >
                                             <span [innerHtml]="'FirstName' | translator: 'base'">First Name</span>
                                             <span
                                                  class="text-danger text-center ms-1"
                                                  [title]="'Required' | translator: 'base'"
                                             >*</span>
                                        </label>
                                        <input
                                             [title]="'FirstName' | translator: 'base'"
                                             class="bg-light form-control"
                                             type="text"
                                             [id]="getUniqueIdentifier('driverFirstName', 'input', [index])"
                                             [attr.name]="getUniqueIdentifier('driverFirstName', 'input', [index])"
                                             [attr.aria-labelledby]="getUniqueIdentifier('driverFirstName', 'label', [index])"
                                             [(ngModel)]="r.firstName"
                                             maxlength="30"
                                             (change)="validateText(r.firstName, r.firstNameValidation)"
                                        />
                                        <span
                                             class="help-block text-danger"
                                             *ngIf="r.firstNameValidation.isDirty && r.firstNameValidation.hasRequiredError"
                                             [innerHtml]="'FirstNameRequired' | translator: 'request'"
                                        >First name is required.
                                        </span>
                                        <span
                                             class="help-block text-danger"
                                             *ngIf="r.firstNameValidation.hasInvalidCharacters"
                                             [innerHtml]="'FirstNameInvalid' | translator: 'request'"
                                        >First name contains invalid value(s). Please use only letters, apostrophes and spaces.
                                        </span>
                                        <span
                                             class="help-block text-danger"
                                             *ngIf="r.firstNameValidation.hasTooManyCharacters"
                                             [innerHtml]="'FirstNameMax30' | translator: 'request'"
                                        >First Name must be 30 characters or less.
                                        </span>
                                   </div>
                                   <div class="col-12 col-md-6 col-xl mb-3 mb-md-0 mb-xl-0 pe-md-2 px-xl-2">
                                        <label
                                             [id]="getUniqueIdentifier('dateOfBirth', 'label', [index])"
                                             [attr.name]="getUniqueIdentifier('dateOfBirth', 'label', [index])"
                                             [for]="getUniqueIdentifier('dateOfBirth', 'input', [index])"
                                             class="form-label text-nowrap"
                                        >
                                             <span [innerHtml]="'DOB' | translator: 'request'">Date of Birth</span>
                                             <span
                                                  class="text-danger text-center ms-1"
                                                  [title]="'Required' | translator: 'base'"
                                             >*</span>
                                        </label>
                                        <input
                                             [title]="'DOB' | translator: 'request'"
                                             class="bg-light form-control"
                                             type="text"
                                             placeholder="12/31/1989"
                                             mask="00/00/0000"
                                             [id]="getUniqueIdentifier('dateOfBirth', 'input', [index])"
                                             [name]="getUniqueIdentifier('dateOfBirth', 'input', [index])"
                                             [attr.aria-labelledby]="getUniqueIdentifier('dateOfBirth', 'label', [index])"
                                             [(ngModel)]="r.dateOfBirthEntry"
                                             (change)="validateDateOfBirth(r)"
                                        />
                                        <span
                                             *ngIf="r.dobValidation.hasStandardDOBError === true && r.dobValidation.isDirty"
                                             class="text-danger text-center"
                                             [innerHtml]="'StandardDOBError' | translator: 'request'"
                                        >* Required. Format must be 12/31/1985.
                                        </span>
                                        <span
                                             *ngIf="r.dobValidation.hasInvalidDOBError === true"
                                             class="text-danger text-center"
                                             [innerHtml]="'InvalidDOBError' | translator: 'base'"
                                        >Enter a valid date.
                                        </span>
                                        <span
                                             *ngIf="r.dobValidation.isTooYoungError === true"
                                             class="text-danger text-center"
                                             [innerHtml]="'TooYoungError' | translator: 'request'"
                                        >You must be 18-years-old.
                                        </span>
                                   </div>
                                   <div class="col-12 col-md-6 col-xl mb-0 mb-md-0 mb-xl-0 ps-md-2 ps-xl-2">
                                        <div class="text-nowrap">
                                             <label
                                                  [attr.name]="getUniqueIdentifier('internalReference', 'label', [index])"
                                                  [id]="getUniqueIdentifier('internalReference', 'label', [index])"
                                                  [for]="getUniqueIdentifier('internalReference', 'input', [index])"
                                                  class="form-label"
                                             >
                                                  <span
                                                       [innerHtml]="'InternalReference' | translator: 'request'"
                                                       class="pr-1"
                                                  >Internal Reference</span>&nbsp;
                                                  
                                                  <ng-template #InternalReferenceTooltip let-tooltip>
                                                       <div [innerHtml]="'IIRef' | translator: 'request'">Internal Reference tooltip</div>
                                                  </ng-template>
                                                  <button type="button" class="btn btn-link btn-tooltip bg-white border-0 p-0" placement="top" [ngbTooltip]="InternalReferenceTooltip">
                                                       <i class="fas fa-circle-info" aria-hidden="true"></i>
                                                       <div class="visually-hidden">Internal Reference tooltip</div>
                                                  </button>                                
                                             </label>

                                        </div>						
                                        <input
                                             [title]="'InternalReference' | translator: 'request'"
                                             class="bg-light form-control"
                                             type="text"
                                             [id]="getUniqueIdentifier('internalReference', 'input', [index])"
                                             [name]="getUniqueIdentifier('internalReference', 'input', [index])"
                                             [attr.aria-labelledby]="getUniqueIdentifier('internalReference', 'label', [index])"
                                             [(ngModel)]="r.internalReference"
                                             maxlength="256"
                                             (keyup)="validateText(r.internalReference, r.internalReferenceValidation)"
                                        />

                                        <span
                                             class="help-block text-danger"
                                             *ngIf="r.firstNameValidation.hasTooManyCharacters"
                                             [innerHtml]="'InternalReferenceMax256' | translator: 'request'"
                                        >Internal Reference must be 256 characters or less.
                                        </span>
                                   </div>
                              </div>
                              <hr>
                              <fieldset class="">
                                   <legend 
                                        class="h5"
                                        [innerHtml]="'DriverInfoPanelSubHeader' | translator: 'request'"
                                   >LICENSES FOR THIS DRIVER
                                   </legend>
                                   <div class="row gx-2">
                                        <div class="d-none d-xl-block col-xl-4 pe-md-2 pe-xl-2">
                                             <label 
                                                  class="form-label" 
                                                  [attr.name]="getUniqueIdentifier('licenseLastName', 'label', [index])" 
                                                  [id]="getUniqueIdentifier('licenseLastName', 'label', [index])"
                                                  [for]="getUniqueIdentifier('dlLastName', 'input', [index])"
                                             >
                                                  <span [innerHtml]="'LastName' | translator: 'base'">Last Name</span>
                                                  <span
                                                       class="text-danger text-center ms-1"
                                                       [title]="'Required' | translator: 'base'"
                                                  >*</span>
                                             </label>
                                        </div>
                                        <div class="d-none d-xl-block col-xl-4 ps-md-2 px-xl-2">
                                             <label 
                                                  class="form-label"
                                                  [attr.name]="getUniqueIdentifier('licenseNumber', 'label', [index])" 
                                                  [id]="getUniqueIdentifier('licenseNumber', 'label', [index])"
                                                  [attr.for]="getUniqueIdentifier('licenseNumber', 'input', [index])"                                                 
                                             >
                                                  <span [innerHtml]="'LicenseNumber' | translator: 'request'">License Number</span>
                                                  <span
                                                       class="text-danger text-center ms-1"
                                                       [title]="'Required' | translator: 'base'"
                                                  >*</span>&nbsp;
                                                  <ng-template #LicenseNumTip let-tooltip>
                                                       <div style="text-align: left;" [innerHtml]="'LicenseNumberTT' | translator: 'request'">License Number tooltip</div>
                                                  </ng-template>
                                                  <button type="button" class="btn btn-link btn-tooltip bg-white border-0 p-0" placement="top" [ngbTooltip]="LicenseNumTip">
                                                       <i class="fas fa-circle-info" aria-hidden="true"></i>
                                                       <div class="visually-hidden">Internal Reference tooltip</div>
                                                  </button>                                                       
                                             </label>
																	
                                        </div>
                                        <div class="d-none d-xl-block col-xl pe-md-2 px-xl-2">
                                             <label 
                                                  class="form-label text-nowrap"
                                                  [attr.name]="getUniqueIdentifier('licenseState', 'label', [index])" 
                                                  [id]="getUniqueIdentifier('licenseState', 'label', [index])"
                                                  [attr.for]="getUniqueIdentifier('licenseState', 'select', [index])"
                                             
                                             >
                                                  <span [innerHtml]="'State' | translator: 'base'">State</span>
                                                  <span
                                                       class="text-danger text-center ms-1"
                                                       [title]="'Required' | translator: 'base'"
                                                  >*</span>
                                             </label>
                                        </div>
                                   </div>
                                   <div
                                        class="row gx-2"
                                        *ngFor="let dl of r.licenses; index as dlIndex"
                                        [id]="'driver-'+index+'license-'+dlIndex"
                                   >
                                        <div class="col-12 col-md-6 col-xl-4 mb-3 pe-md-2 pe-xl-2">
                                             <label
                                                  [attr.name]="getUniqueIdentifier('dlLastNameSmall', 'label', [index,dlIndex])" 
                                                  [id]="getUniqueIdentifier('dlLastNameSmall', 'label', [index,dlIndex])" 
                                                  [for]="getUniqueIdentifier('dlLastName', 'input', [index, dlIndex])"
                                                  class="form-label d-xl-none" 
                                             >
                                                  <span [innerHtml]="'LastName' | translator: 'base'">Last Name</span>
                                                  <span
                                                       class="text-danger text-center ms-1"
                                                       [title]="'Required' | translator: 'base'"
                                                  >*</span>
                                             </label>
                                             <label
                                                  [attr.name]="getUniqueIdentifier('dlLastNameLarge', 'label', [index,dlIndex])"
                                                  [id]="getUniqueIdentifier('dlLastNameLarge', 'label', [index,dlIndex])"
                                                  [for]="getUniqueIdentifier('dlLastName', 'input', [index, dlIndex])"
                                                  class="form-label sr-only d-none d-xl-block"
                                             >
                                                  <span [innerHtml]="'LastName' | translator: 'base'">Last Name</span>
                                                  <span
                                                       class="text-danger text-center ms-1"
                                                       [title]="'Required' | translator: 'base'"
                                                  >*</span>
                                             </label>
                                             <input
                                                  type="text"
                                                  [id]="getUniqueIdentifier('dlLastName', 'input', [index, dlIndex])"
                                                  [name]="getUniqueIdentifier('dlLastName', 'input', [index, dlIndex])"
                                                  [attr.aria-labelledby]="getUniqueIdentifier('licenseLastName', 'label', [index])"
                                                  class="bg-light form-control"
                                                  [(ngModel)]="dl.lastName"
                                                  [title]="'LastName' | translator: 'base'"
                                                  maxlength="30"
                                                  (change)="licenseValueChanged(dl.lastName, dl.lastNameValidation, r)"
                                             />
                                             <span
                                                  class="help-block text-danger"
                                                  *ngIf="dl.lastNameValidation.hasRequiredError && dl.lastNameValidation.isDirty"
                                                  [innerHtml]="'LastNameRequired' | translator: 'request'"
                                             >Last name is required.
                                             </span>
                                             <span
                                                  class="help-block text-danger"
                                                  *ngIf="dl.lastNameValidation.hasInvalidCharacters"
                                                  [innerHtml]="'LastNameInvalid' | translator: 'request'"
                                             >Last name contains invalid value(s). Please use only letters, apostrophes and spaces.
                                             </span>
                                             <span
                                                  class="help-block text-danger"
                                                  *ngIf="dl.lastNameValidation.hasTooManyCharacters"
                                                  [innerHtml]="'LastNameMax30' | translator: 'request'"
                                             >Last name must be 30 characters or less.
                                             </span>
                                        </div>
                                        <div class="col-12 col-md-6 col-xl-4 mb-3 ps-md-2 px-xl-2">
                                             <div class="d-xl-none">
                                                  <label
                                                       [attr.name]="getUniqueIdentifier('licenseNumber', 'label', [index,dlIndex])"
                                                       [id]="getUniqueIdentifier('licenseNumber', 'label', [index,dlIndex])"
                                                       [for]="getUniqueIdentifier('licenseNumber', 'input', [index, dlIndex])"
                                                       class="form-label"
                                                       [ngbTooltip]="LicenseNumTip"
                                                  >
                                                       <span
                                                            [innerHtml]="'LicenseNumber' | translator: 'request'"
                                                       >License Number
                                                       </span>
                                                       <span
                                                            class="text-danger text-center ms-1"
                                                            [title]="'Required' | translator: 'base'"
                                                       >*</span>
                                                  </label>
                                                  <ng-template #LicenseNumTip let-tooltip>
                                                       <i class="fas fa-circle-info" aria-hidden="true"></i>
                                                       <span [innerHtml]="'LicenseNumberTT' | translator: 'request'">License Number tooltip</span>                                                       
                                                  </ng-template>
                                             </div>
                                             <input
                                                  [title]="'LicenseNumber' | translator: 'request'"
                                                  class="bg-light form-control"
                                                  type="text"
                                                  [id]="getUniqueIdentifier('licenseNumber', 'input', [index, dlIndex])"
                                                  [name]="getUniqueIdentifier('licenseNumber', 'input', [index, dlIndex])"
                                                  [attr.aria-labelledby]="getUniqueIdentifier('licenseNumber', 'label', [index])" 
                                                  [(ngModel)]="dl.licenseNumber"
                                                  maxlength="20"
                                                  (change)="licenseValueChanged(dl.licenseNumber, dl.licenseNumberValidation, r)"
                                             />
                                             <span
                                                  class="help-block text-danger"
                                                  *ngIf="dl.licenseNumberValidation.isDirty && dl.licenseNumberValidation.hasRequiredError"
                                                  [innerHtml]="'LicenseNumberRequired' | translator: 'request'"
                                             >License Number is required.
                                             </span>
                                             <span
                                                  class="help-block text-danger"
                                                  *ngIf="dl.licenseNumberValidation.hasInvalidCharacters"
                                                  [innerHtml]="'LicenseNumberInvalid' | translator: 'request'"
                                             >License Number contains invalid value(s). Please use only letters and numbers.
                                             </span>
                                             <span
                                                  class="help-block text-danger"
                                                  *ngIf="dl.licenseNumberValidation.hasTooManyCharacters"
                                                  [innerHtml]="'LicenseNumberMax20' | translator: 'request'"
                                             >License Number must be 20 characters or less.
                                             </span>
                                        </div>
                                        <div class="col-12 col-md-6 col-xl mb-3 pe-md-2 px-xl-2">
                                             <label
                                                  [attr.name]="getUniqueIdentifier('licenseState', 'label', [index,dlIndex])"
                                                  [id]="getUniqueIdentifier('licenseState', 'label', [index,dlIndex])"
                                                  [for]="getUniqueIdentifier('licenseState', 'select', [index, dlIndex])"
                                                  class="form-label text-nowrap d-xl-none"
                                             >
                                                  <span [innerHtml]="'State' | translator: 'base'">State</span>
                                                  <span
                                                       class="text-danger text-center ms-1"
                                                       [title]="'Required' | translator: 'base'"
                                                  >*</span>
                                             </label>
                                             <select
                                                  [(ngModel)]="dl.licenseState"
                                                  [id]="getUniqueIdentifier('licenseState', 'select', [index, dlIndex])"
                                                  [name]="getUniqueIdentifier('licenseState', 'select', [index, dlIndex])"
                                                  [attr.aria-labelledby]="getUniqueIdentifier('licenseState', 'label', [index])" 
                                                  class="bg-light form-select"
                                                  [title]="'State' | translator: 'request'"
                                                  (change)="licenseValueChanged(dl.licenseState, dl.licenseStateValidation, r)"
                                             >
                                                  <optgroup
                                                       *ngFor="let group of groupedNationStates; index as groupIndex"
                                                       [label]="group.country"
                                                       [attr.key]="groupIndex"
                                                  >
                                                       <option
                                                            *ngFor="let state of group.states"
                                                            [value]="state"
                                                            [attr.key]="state"
                                                            [id]="getUniqueIdentifier('licenseState', 'option', [state, index, dlIndex])"
                                                            [attr.name]="getUniqueIdentifier('licenseState', 'option', [state, index, dlIndex])"
                                                       >{{ state }}
                                                       </option>
                                                  </optgroup>
                                             </select>
                                             <span
                                                  class="help-block text-danger"
                                                  *ngIf="dl.licenseStateValidation.hasRequiredError"
                                                  [innerHtml]="'StateRequired' | translator: 'request'"
                                             >State is required.
                                             </span>
                                        </div>
                                        <div
                                             class="col-12 col-md-6 col-xl-auto mb-3 ps-md-2 ps-xl-2 align-self-start"
                                             *ngIf="r.licenses.length > 1"
                                        >
                                             <button
                                                  (click)="removeLicense(r,dl)"
                                                  class="btn btn-danger btn-mt-32"
                                                  [title]="'Delete' | translator: 'base'"
                                                  [id]="getUniqueIdentifier('delete', 'button', [index, dlIndex])"
                                                  [name]="getUniqueIdentifier('delete', 'button', [index, dlIndex])"
                                             >
                                                  <span
                                                       [innerHtml]="'Delete' | translator: 'base'"
                                                       [title]="'Delete' | translator: 'base'"
                                                  >Delete
                                                  </span>
                                             </button>
                                        </div>
                                        <div
                                             class="col-12 d-xl-none"
                                             *ngIf="r.licenses.length > 1"
                                        >
                                             <hr class="mt-0">
                                        </div>
                                   </div>
                                   <div class="row justify-content-center">
                                        <div
                                             class="col align-self-center col-12"
                                             *ngIf="r.hasDuplicateLicense"
                                        >
                                             <div class="alert alert-danger">
                                                  <p [innerHtml]="'DuplicateEntered' | translator: 'request'">
                                                       You have entered two or more identical licenses. Please edit any duplicate licenses or use the “Delete” button to remove them entirely.
                                                  </p>
                                             </div>
                                        </div>
                                        <div class="col-12">
                                             <button
                                                  (click)="addLicense(r)"
                                                  class="btn btn-outline-primary"
                                                  [disabled]="r.hasDuplicateLicense"
                                                  [title]="'AddAnotherLicense' | translator: 'request'"
                                                  [id]="getUniqueIdentifier('addLicense', 'button', [index])"
                                                  [name]="getUniqueIdentifier('addLicense', 'button', [index])"
                                             >
                                                  <span
                                                       [innerHtml]="'AddAnotherLicense' | translator: 'request'"
                                                       [title]="'AddAnotherLicense' | translator: 'request'"
                                                  >Add Another License
                                                  </span>
                                             </button>
                                        </div>
                                   </div>
                              </fieldset>
                              <hr>
                              <div class="row">
                                   <div class="col-12">
                                        <div class="form-check">
                                             <input
                                                  [id]="getUniqueIdentifier('certify', 'check', [index])"
                                                  [name]="getUniqueIdentifier('certify', 'check', [index])"
                                                  class="form-check-input"
                                                  type="checkbox"
                                                  [(ngModel)]="r.disclosureAndAuthorizationCertified"
                                                  value="0"
                                                  [disabled]="!isFormValidBeforeAthorizationChecked({})"
                                             >
                                             <label
                                                  [innerHtml]="'ICertify' | translator: 'request'"
                                                  class="form-check-label"
                                                  [for]="getUniqueIdentifier('certify', 'check', [index])"
                                             >
                                                  I certify under penalty of perjury that the company I represent has disclosed to the operator-applicant that their PSP record will be requested and has received the operator-applicant's authorization for this inquiry.
                                                  I understand this record will be available for viewing for five days (120 hours) from the time of purchase.
                                             </label>
                                        </div>
                                   </div>
                              </div>

                              <div
                                   class="row justify-content-center pt-3"
                                   *ngIf="onProbation && r.disclosureAndAuthorizationCertified"
                              >
                                   <div class="col-12 col-sm-3 px-3">
                                        <button
                                             id="UploadForm"
                                             name="UploadForm"
                                             class="btn btn-primary w-100 mb-0"
                                             [disabled]="!isPageValid({}) || probationDocuments.length > 0"
                                             (click)="openUploadModal()"
                                        >
                                             <span *ngIf="probationDocuments.length == 0"
                                                  [innerHtml]="'UploadForm' | translator: 'request'"
                                                  [title]="'UploadForm' | translator: 'request'"
                                             >Upload Form</span>
                                             <span *ngIf="probationDocuments.length > 0"
                                                  [innerHtml]="'UploadComplete' | translator: 'request'"
                                                  [title]="'UploadComplete' | translator: 'request'"
                                             >Upload Complete</span>
                                        </button>
                                   </div>
                                   <div
                                        class="col-12 col-sm-9"
                                        [innerHtml]="'UploadFormDescription' | translator: 'request'"
                                   >
                                        Your account is currently in probation status.
                                        While in probation, your company is required to submit a legible copy of the driver's disclosure and authorization form for each PSP record requested. Use the Upload Form button to submit the driver's disclosure and authorization form. Acceptable file formats are PDF, JPEG, and PNG.
                                   </div>
                              </div>

                              <div
                                   class="row justify-content-center pt-3"
                                   *ngIf="onProbation && r.disclosureAndAuthorizationCertified"
                              >
                                   <div class="col-12 col-sm-3">
                                        <button
                                             id="showFaxCoversheet"
                                             name="showFaxCoversheet"
                                             class="btn btn-primary w-100 mb-0"
                                             (click)="showFaxCoverSheet()"
                                        >
                                             <span
                                                  [innerHtml]="'FaxForm' | translator: 'request'"
                                                  [title]="'FaxForm' | translator: 'request'"
                                             >Fax Form</span>
                                        </button>
                                   </div>
                                   <div
                                        class="col-12 col-sm-9"
                                        [innerHtml]="'FaxFormDescription' | translator: 'request'"
                                   >Use the Fax Form button to print a pre-populated fax cover sheet.
                                   </div>
                              </div>

                              <div class="row">
                                   <div class="col-12">
                                        <button
                                             (click)="removeRecordRequest(r)"
                                             class="btn btn-danger mt-3"
                                             [title]="'RemoveDriver' | translator: 'request'"
                                             [id]="getUniqueIdentifier('removeDriver', 'button', [index])"
                                             [name]="getUniqueIdentifier('removeDriver', 'button', [index])"
                                             *ngIf="count > 1"
                                        >
                                             <span
                                                  class="pl-2"
                                                  [innerHtml]="'RemoveDriver' | translator: 'request'"
                                                  [title]="'RemoveDriver' | translator: 'request'"
                                             >
                                                  Remove Driver
                                             </span>
                                        </button>
                                   </div>
                              </div>
                         </div>
                    </fieldset>

                    <div
                         class="row mt-3"
                         *ngIf="!onProbation"
                    >
                         <div class="col-12 mb-3 mb-lg-0">
                              <button
                                   id="addDriver"
                                   name="addDriver"
                                   class="btn btn-primary"
                                   (click)="addNewRecordRequest()"
                                   [disabled]="!isPageValid({})"
                              >
                                   <span
                                        [innerHtml]="'AddDriver' | translator: 'request'"
                                        [title]="'AddDriver' | translator: 'request'"
                                   >Add Driver</span>
                              </button>
                              <span
                                   *ngIf="recordRequests.length > 1" 
                                   class="px-2 psp-scroll-to-top-btn"
                              >
                                   <app-scroll-to-top></app-scroll-to-top>
                              </span>     
                         </div>
                    </div>
               </div>

               <div class="col-lg-4 sidebar">
                    <div
                         id="orderSummary"
                         name="orderSummary"
                         class="card shadow-sm rounded-0 border-0"
                    >
                         <div class="card-body">
                              <h2
                                   class="card-title h5"
                                   [innerHtml]="'AddedDrivers' | translator: 'request'"
                              >Added Driver(s)
                              </h2>
                              <div class="row">
                                   <span
                                        class="col-12 caption"
                                        [innerHtml]="'TransactionDetails' | translator: 'request'"
                                   >Transaction details
                                   </span>
                              </div>
                              <hr>
                              <div class="row">
                                   <div
                                        class="col col-auto fw-bold"
                                        [innerHtml]="'Drivers' | translator: 'request'"
                                   >
                                        Driver(s)
                                   </div>
                                   <div class="col text-right">
                                        {{ this.count }}
                                   </div>
                              </div>
                              <hr>
                              <div class="row">
                                   <div
                                        class="col col-auto fw-bold"
                                        [innerHtml]="'PricePerRecord' | translator: 'request'"
                                   >
                                        Price per Record
                                   </div>
                                   <div class="col text-right">
                                        {{ formatCurrency(this.pricePer) }}
                                   </div>
                              </div>
                              <hr>
                              <div class="row">
                                   <div
                                        class="col-auto fw-bold"
                                        [innerHtml]="'TransactionTotal' | translator: 'request'"
                                   >
                                        Transaction Total
                                   </div>
                                   <div class="col text-right">
                                        {{ formatCurrency(this.transactionTotal) }}
                                   </div>
                              </div>
                              <hr>
                              <div class="row">
                                   <div class="col-12">
                                        <button
                                             id="submitRequest"
                                             name="submitRequest"
                                             class="btn btn-primary btn-strong"
                                             [disabled]="!isPageValid({})"
                                             (click)="submitRequests()"
                                        >
                                             <span
                                                  [innerHtml]="'SubmitRequest' | translator: 'request'"
                                                  [title]="'SubmitRequest' | translator: 'request'"
                                             >Submit Request</span>
                                        </button>
                                   </div>
                              </div>
                         </div>
                    </div>
               </div>

               <div class="psuedo-hidden" [innerHtml]="translate('Voodoo',{})" >Voodoo!!! DO NOT CHANGE TO display:none or translation won't be triggered and grid language will not change on language drop down change.</div>
          </div>
     </div>
</section>
